function AdminUpdatePage() {
    return (
        <>Admin Update Page</>
    );
}

export default AdminUpdatePage;